import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import * as moment from "moment";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { GetVenueTimeZoneOffset$Params } from "src/api/generated/fn/venue/get-venue-time-zone-offset";
import { VenueService } from "src/api/generated/services";
import { RoleNameEnum } from "src/app/admin-panel/enums/role-name.enum";

@Injectable({
  providedIn: 'root'
})
export class CurrentVenueHelperService {
  private updateDropdown = new Subject<string | null | undefined>();
  private timezone = new BehaviorSubject<number | null | undefined>(undefined);

  private readonly access_token = 'pos_access_token';
  get token(): any {
    return localStorage.getItem(this.access_token);
  }

  constructor(private venueService: VenueService, 
              private _jwtHelperService: JwtHelperService){
  }

  public onUpdateRoute(): Observable<string | null | undefined> {
    return this.updateDropdown.asObservable();
  }

  public getTimezone(): Observable<number | null | undefined> {
    return this.timezone.asObservable();
  }

  public updateCurrentVenueIdDropdown(currentVenueId: string | undefined): void {
      this.updateDropdown.next(currentVenueId);
      if(currentVenueId != undefined){
        if(this._jwtHelperService.decodeToken(this.token).rlnm.includes(RoleNameEnum.PosManager)){
          const params: GetVenueTimeZoneOffset$Params = { venueId: currentVenueId };
          this.venueService.getVenueTimeZoneOffset(params).subscribe((response: any) => this.timezone.next(parseInt(response.timeZoneOffset)));
        } else{
          const params:GetVenueTimeZoneOffset$Params = { venueId: currentVenueId };
          this.venueService.getVenueTimeZoneOffset(params).subscribe((response: any) => this.timezone.next(parseInt(response.timeZoneOffset)));
        }
      }
  }

  public resetCurrentVenueIdDropdown(): void {
    this.updateDropdown.next(null);
  }
  public resetTimezone(): void {
    this.timezone.next(null);
  }
}
